import { FC } from "react";

import { useUrlMappingCreatePageParams } from "~/src/routes/hooks";

import { UrlMappingCreateFormContainer } from "../../features/settings/UrlMappingForm";

import { UrlMappingCreatePage } from "./presentations";

export const UrlMappingCreatePageContainer: FC = () => {
  const { siteSlug } = useUrlMappingCreatePageParams();

  return (
    <UrlMappingCreatePage siteSlug={siteSlug}>
      <UrlMappingCreateFormContainer siteSlug={siteSlug} />
    </UrlMappingCreatePage>
  );
};
